import { FieldGroup } from '@/ui'
import { Button } from '@dashboard/ui'

export const DangerousButton = (props: {
  onClick: () => void
  btnText: string
  title: string
  subTitle: string
  color?: 'primary' | 'danger'
}) => (
  <div
    className="flex w-full items-center justify-between gap-4 rounded-2xl1 p-6"
    style={{
      boxShadow: `0px 0px 4px 1px ${props.color == 'danger' ? '#EF4444' : '#0097E4'}`,
    }}
  >
    <FieldGroup label={props.title}>
      <div className="text-text-tertiary">{props.subTitle}</div>
    </FieldGroup>
    <div className="flex min-w-[100px] items-center justify-end">
      <Button color={props.color} onClick={props.onClick}>
        {props.btnText}
      </Button>
    </div>
  </div>
)
